import React from "react";
import ReactDOM from "react-dom/client";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import { BrowserRouter } from 'react-router-dom';
import Feature from './feature-module/feature';
import CanonicalTag from "./components/CanonicalTag";
import 'aos/dist/aos.css';
import { Provider } from 'react-redux';
import store from './core/data/redux/store';
import '../src/style/scss/main.scss'
import '../src/style/css/feather.css'
import './index.scss';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { base_path } from "./environment";
import { PrimeReactProvider } from "primereact/api";
import { configureSweetAlertNotifications } from "./utils/sweetAlertNotifications";



configureSweetAlertNotifications();

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <PrimeReactProvider value={{ hideOverlaysOnDocumentScrolling: true }}>
        <Provider store={store}>
          <BrowserRouter basename={base_path}>
            <CanonicalTag />
            <Feature />
          </BrowserRouter>
        </Provider>
      </PrimeReactProvider>
    </React.StrictMode>
  );
}
